import {environment} from '@/config/environment';
import {appConfig} from '@/config/appConfig';

export const OUTLOOK_PREFIX = 'outlook';

const getRedirectOrigin = () => {
    // Use dev url for local development (*.local domains)
    if (appConfig.isLocalDevelopment) {
        return environment.VITE_DEV_BASE_URL;
    }

    // For Zrok URLs (*.share.deskly.live), keep the original subdomain
    if (window.location.hostname.endsWith('.share.deskly.live')) {
        return window.location.origin;
    }

    return window.location.origin.replace(new RegExp(/(https:\/\/)([\w-]+)(\..+)/i), '$1app$3');
};

const getRedirectUri = () => {
    // Dynamically import router to avoid circular dependency
    return import('../../router/router').then(({default: router}) => {
        return getRedirectOrigin() + router.resolve({name: 'AdminCalendarSettings'}).href;
    });
};

export const getOutlookConfig = async () => ({
    url: 'https://login.microsoftonline.com/organizations/oauth2/v2.0/authorize',
    clientId: environment.VITE_OAUTH_AZURE_ID,
    redirectUri: await getRedirectUri(),
    scope: 'openid',
    responseType: 'code',
});

export const getOutlookAdminConsentConfig = async () => ({
    url: 'https://login.microsoftonline.com/organizations/adminconsent',
    clientId: environment.VITE_OAUTH_AZURE_ID,
    redirectUri: await getRedirectUri(),
});
